import { QuotationImportPersistedState } from './types';

const storageKey = (saleOrderId: string) => `quotation-import:${saleOrderId}`;

export const loadQuotationImportState = (saleOrderId: string): QuotationImportPersistedState | null => {
	try {
		const raw = sessionStorage.getItem(storageKey(saleOrderId));
		if (!raw) return null;
		return JSON.parse(raw) as QuotationImportPersistedState;
	} catch {
		return null;
	}
};

export const saveQuotationImportState = (state: QuotationImportPersistedState): void => {
	sessionStorage.setItem(storageKey(state.saleOrderId), JSON.stringify(state));
};

export const clearQuotationImportState = (saleOrderId: string): void => {
	sessionStorage.removeItem(storageKey(saleOrderId));
};
